export default "__VITE_ASSET__COLOjfPY__"